import { render, staticRenderFns } from "./AddEdtMemberDlg.vue?vue&type=template&id=20ae9ea2"
import script from "./AddEdtMemberDlg.vue?vue&type=script&lang=js"
export * from "./AddEdtMemberDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports